import L from 'leaflet';

const key = window.MapTilerApiKey; // MapTiler API key gets transformed per enviroment and is domain restricted
const mapType = 'basic'; // should correspond with the raster map name https://cloud.maptiler.com/maps/

export const mapTileUrl = `https://api.maptiler.com/maps/${mapType}/{z}/{x}/{y}.png?key=${key}`;

export const mapTileSettings = {
    tileSize: 512,
    zoomOffset: -1,
    minZoom: 1,
    attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>',
    crossOrigin: true
};

export const mapIcon = L.divIcon({
    className: 'map-icon',
    iconSize: [40, 40],
    iconAnchor: [20, 40]
});